
import { Component, Injector, OnInit } from '@angular/core';
import { TableInfoService } from 'tnx-admin-service/tableinfo/services';
import {
    ComponentContextService, DataFormBase, FormSchemaBase, TextControlSchema
} from 'tnx-shared';

@Component({
    selector: 'tableinfo-form',
    templateUrl: './tableinfo-form.component.html',
    styleUrls: ['./tableinfo-form.component.scss'],
    providers: [ComponentContextService],
})
export class TableInfoFormComponent extends DataFormBase implements OnInit {

    constructor(
        protected _injector: Injector,
        private _tableInfoService: TableInfoService
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._tableInfoService;
        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'ten',
                label: 'Tên bảng'
            }),
            new TextControlSchema({
                field: 'code',
                label: 'Mã bảng'
            })
        ];
    }
}

